import React, { useEffect, useRef }  from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import ProductCard from "./ProductCard";

import '../styles/Product.scss'

const ProductTemplate = ({className, id, copy, src, alt, cardData}) => {

    const ref = useRef();
    
    
    useEffect(() => {

        gsap.registerPlugin(ScrollTrigger);
        
            const element = ref.current;
            const trigger = element.querySelector('.product__inner');
            const mainTitle = element.querySelector('.product__mainTitle');
            const sectionHeight = element.clientHeight;
            console.log(trigger);
            console.log(sectionHeight);

            //見出し固定
            ScrollTrigger.matchMedia({
            "(min-width: 768px)": () => {
                ScrollTrigger.create({
                    trigger: trigger,
                    pin: mainTitle,
                    pinSpacing: false,
                    start: "top top+=50",
                    end: "bottom-=15% center",
                    normalizeScroll: true,
                    ignoreMobileResize: true
                    // end: () => `+=${sectionHeight - 1000}`,
                    // toggleActions: 'play pause resume reset',
                    // markers: true,
                    });
                },
            "(max-width: 767px)": () => {
            ScrollTrigger.create({
                trigger: trigger,
                pin: mainTitle,
                pinSpacing: false,
                start: "top top+=30",
                end: '+=1000',
                normalizeScroll: true,
                ignoreMobileResize: true
                // end: "bottom-=20% center",
                // end: () => `+=${sectionHeight}`,
                // toggleActions: 'play pause resume reset',
                // markers: true,
                });
            },
        }); 

        const mainPic = element.querySelector('.product__mainPic');
        //画像順番に表示
        gsap.set(mainPic, {
            y: 50,
            opacity: 0,
        });
        gsap.to(mainPic, {
            duration: 1.5,
            y: 0,
            opacity: 1,
            ease: "power2.out",
            scrollTrigger: {
                trigger: mainPic,
                start: 'top center+=40%',
                // markers: true,
            }
        });

    },[]);
    


    const listItems = cardData.map((data, index) => (
        <ProductCard {...data} key={index} />
    ))

    return (
        <section className={className} id={id} ref={ref}>
            <div className="product__inner">
                <div className="product__mainTitle"></div>
                <div className="product__mainPic">
                    <div><img src={src} alt={alt} width="500" height="642"/></div>
                </div>
                <p className="product__catch">{copy}</p>
                {listItems}
            </div>
        </section>
    )
}

export default ProductTemplate